// Normaliza la respuesta de la API para que siempre tenga las mismas keys
export const normalizeBulkCreate = (raw) => {
  if (!raw || typeof raw !== "object") {
    return {
      created: 0,
      updated: 0,
      errors: [],
      items: [],
      created_items: [],
      updated_items: [],
    };
  }
  const items = raw.items ?? [];
  return {
    created: raw.created ?? 0,
    updated: raw.updated ?? 0,
    errors: raw.errors ?? [],
    items,
    created_items: raw.created_items ?? [],
    updated_items: raw.updated_items ?? [],
  };
};

export const buildSummary = (apiResult, opts = {}) => {
  const normalized = normalizeBulkCreate(apiResult);
  const { selectedUsers } = opts;

  // Caso por Excel
  if (!selectedUsers || selectedUsers.length === 0) {
    return {
      created: normalized.created_items,
      updated: normalized.updated_items,
      errors: (normalized.errors || []).map((e) => ({
        ...e,
        user: e.user,
        message: e.message,
        user_id: e.user_id,
      })),
      raw: normalized,
    };
  }

  // Caso por interfaz (con usuarios seleccionados)
  const toNum = (v) => Number(v);
  const index = new Map(selectedUsers.map((u) => [toNum(u.id), u]));

  const withUser = (arr) => (arr || []).map((item) => ({ ...item, user: index.get(toNum(item.user_id)) })).filter((item) => !!item.user);

  const created = withUser(normalized.created_items);
  const updated = withUser(normalized.updated_items);
  const errorList = withUser(normalized.errors || []);

  return { created, updated, errors: errorList, raw: normalized };
};
